import React from "react";
import { message, notification, person } from "./assets";
import colors from "../../utils/colors";
import {
  HelpIcon,
  LogoutSmallIcon,
  NotificationIcon,
  SettingsIcon,
  SinglePersonIcon,
  down_Arr,
} from "../../assets";
import PopoverCmp from "../popover/Popover";
import { Badge, Box, Flex, IconButton, Img, Text } from "@chakra-ui/react";
import { useAppSelector } from "../../hooks/useAppSelector";

import { useNavigate } from "react-router-dom";
import { handleLogout } from "../../utils/logout";
import { ArrowBackIcon, BellIcon } from "@chakra-ui/icons";

import { FlexProps } from "@chakra-ui/react";
import { useUnreadNotificationCount } from "../../apis/doctor";
export interface IProps extends Omit<FlexProps, "title"> {
  headerContent: React.ReactNode;
}

const DesktopHeader = ({ headerContent, ...rest }: IProps) => {
  const { doctorInfo } = useAppSelector((state) => state.auth);
  const userId = doctorInfo?._id;

  const { data, isLoading } = useUnreadNotificationCount(userId);
  const unreadCount = data?.data || 0;

  const name = doctorInfo?.name;
  const profilePictureObject = doctorInfo?.profilePicture as
    | { url: string }
    | undefined
    | null;
  const navigate = useNavigate();

  const options = [
    {
      title: "My Profile",
      image: doctorInfo?.profilePicture || person,

      action: () => navigate("/profile"),
    },
    {
      title: "Notifications",
      image: NotificationIcon,
      action: () => navigate("/notifications"),
    },
    {
      title: "Help",
      image: HelpIcon,
      action: () => navigate("/help"),
    },
    {
      title: "Logout",
      image: LogoutSmallIcon,
      action: () => handleLogout(),
    },
  ];

  return (
    <Flex
      as="header"
      align="center"
      justify="space-between"
      w="full"
      px={{ base: "15px", md: "40px" }}
      py={{ base: "10px", md: "20px" }}
      borderBottomWidth="1px"
      borderColor={colors.grey}
      color={colors.dark}
      {...rest}
    >
      <Flex gap={"16px"} alignItems={"center"}>
        {window.history.length > 1 && document.referrer && (
          <ArrowBackIcon
            boxSize={"30px"}
            color={colors.dark}
            cursor={"pointer"}
            onClick={() => navigate(-1)}
          />
        )}
        {headerContent}
      </Flex>

      <div className="flex items-center gap-[30px]">
        <PopoverCmp
          popoverTrigger={
            <div className="flex items-center gap-3 cursor-pointer">
              <Box position="relative">
                <IconButton
                  aria-label="Notifications"
                  icon={<BellIcon />}
                  variant="ghost"
                  colorScheme="gray"
                  size="lg"
                />

                {unreadCount > 0 && (
                  <Badge
                    bg="red.500"
                    color="white"
                    position="absolute"
                    top="0"
                    right="0"
                    fontSize="0.7em"
                    borderRadius="full"
                    minW="16px"
                    h="16px"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    zIndex={1}
                  >
                    {unreadCount}
                  </Badge>
                )}
              </Box>

              <Img
                src={doctorInfo?.profilePicture || person}
                className="h-[50px] w-[50px] rounded-full object-cover"
                alt="Profile"
              />

              <Img src={down_Arr} className="h-[8px]" alt="icon" />
            </div>
          }
        >
          <Flex gap={"12px"} direction={"column"}>
            <Flex p={"16px 20px"} gap={"16px"}>
              <Img
                src={doctorInfo?.profilePicture || person}
                boxSize="40px"
                borderRadius="full"
                objectFit="cover"
              />

              <Box>
                <Text
                  fontFamily={"lato"}
                  fontWeight={700}
                  fontSize={"18px"}
                  color={colors.dark}
                >
                  {name || "Doctor"}
                </Text>

                <Text
                  fontFamily={"lato"}
                  fontWeight={400}
                  fontSize={"16px"}
                  color={colors.dark}
                >
                  {doctorInfo?.roles?.[0]
                    ? doctorInfo.roles[0].charAt(0).toUpperCase() +
                      doctorInfo.roles[0].slice(1)
                    : "User"}
                </Text>
              </Box>
            </Flex>
            <Flex direction={"column"}>
              {options.map((option, index) => (
                <Flex
                  key={index}
                  gap={"20px"}
                  alignItems={"center"}
                  px={"20px"}
                  py={"12px"}
                  cursor={"pointer"}
                  _hover={{
                    backgroundColor: colors.lightGrey,
                  }}
                  onClick={() => option.action()}
                >
                  <Img
                    src={option.image}
                    boxSize={"20px"}
                    alt={`${option.title} icon`}
                  />
                  <Text
                    fontFamily={"lato"}
                    fontWeight={400}
                    fontSize={"16px"}
                    lineHeight={"19.2px"}
                    color={colors.dark}
                  >
                    {option.title}
                  </Text>
                </Flex>
              ))}
            </Flex>
          </Flex>
        </PopoverCmp>
      </div>
    </Flex>
  );
};

export default DesktopHeader;
